// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile {
  display: flex;
  flex-direction: column;
}
.profile__content {
  display: flex;
  flex-direction: row;
  color: black;
}
.profile__content__data {
  padding: 1rem 0 0 4rem;
  width: 80%;
}
.profile__content__data__container {
  padding: 1rem 0 1.5rem 0;
  background-color: #F4F7F9;
  border-radius: 1rem;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.profile__content__data__container__separator {
  width: 0.0625rem;
  background-color: black;
  height: 5rem;
}
.profile__content__data__assets-charts {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 3rem;
}
.profile__content__data__upper-generation-button-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 1rem 0;
}
.profile__content__data__upper-generation-button-container__button {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #4BABB9;
  color: white;
  width: 16rem;
  height: 2rem;
  border-radius: 0.8rem;
  cursor: pointer;
}
.profile__content__data__upper-generation-button-container__data-date {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: black;
  color: white;
  width: 12rem;
  height: 2rem;
  border-radius: 0.8rem;
}
.profile__content__data__generation-button-container {
  width: 100%;
  display: flex;
  justify-content: center;
}
.profile__content__data__generation-button-container__button {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #4BABB9;
  color: white;
  width: 20rem;
  height: 2rem;
  border-radius: 0.8rem;
  cursor: pointer;
  margin-bottom: 3rem;
  font-size: 1.25rem;
  font-weight: 400;
}
.profile__content__data__disclaimer {
  text-align: start;
  font-size: 0.75rem;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/profile/profile.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;AACJ;AAAI;EACI,aAAA;EACA,mBAAA;EACA,YAAA;AAER;AADQ;EACI,sBAAA;EACA,UAAA;AAGZ;AAFY;EACI,wBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAIhB;AAHgB;EACI,gBAAA;EACA,uBAAA;EACA,YAAA;AAKpB;AAFY;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAIhB;AAFY;EACI,WAAA;EACA,aAAA;EACA,8BAAA;EACA,cAAA;AAIhB;AAFgB;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;AAIpB;AADgB;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;AAGpB;AAAY;EACI,WAAA;EACA,aAAA;EACA,uBAAA;AAEhB;AADgB;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAGpB;AAAY;EACI,iBAAA;EACA,kBAAA;AAEhB","sourcesContent":[".profile{\n    display: flex;\n    flex-direction: column;\n    &__content{\n        display: flex;\n        flex-direction: row;\n        color: black;\n        &__data{\n            padding:1rem 0 0 4rem;\n            width: 80%;\n            &__container{\n                padding: 1rem 0 1.5rem 0;\n                background-color: #F4F7F9;\n                border-radius: 1rem;\n                display: flex;\n                flex-direction: row;\n                align-items: center;\n                &__separator{\n                    width: 0.0625rem;\n                    background-color: black;\n                    height: 5rem;\n                }\n            }\n            &__assets-charts{\n                width: 100%;\n                display: flex;\n                flex-direction: row;\n                justify-content: space-between;\n                margin-top: 3rem;\n            }\n            &__upper-generation-button-container{\n                width: 100%;\n                display: flex;\n                justify-content: space-between;\n                margin: 1rem 0;\n\n                &__button{\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    background-color: #4BABB9;\n                    color: white;\n                    width: 16rem;\n                    height: 2rem;\n                    border-radius: 0.8rem;\n                    cursor: pointer;\n                }\n\n                &__data-date{\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    background-color: black;\n                    color: white;\n                    width: 12rem;\n                    height: 2rem;\n                    border-radius: 0.8rem;\n                }\n            }\n            &__generation-button-container{\n                width: 100%;\n                display: flex;\n                justify-content: center;\n                &__button{\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    background-color: #4BABB9;\n                    color: white;\n                    width: 20rem;\n                    height: 2rem;\n                    border-radius: 0.8rem;\n                    cursor: pointer;\n                    margin-bottom: 3rem;\n                    font-size: 1.25rem;\n                    font-weight: 400;\n                }\n            }\n            &__disclaimer{\n                text-align: start;\n                font-size: 0.75rem;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
